import { isDefined } from '@hsp/utilities';

export const savePromptQueryKeys = {
  audienceNames: ['audience-names'] as const,
  audiences: (userId: string | undefined) => {
    if (!isDefined(userId)) {
      throw new Error('User id is required');
    }

    return ['save-prompt-audiences', userId] as const;
  },
} as const;
